import { render, staticRenderFns } from "./Memorandums.vue?vue&type=template&id=8e4f3906&scoped=true"
import script from "./Memorandums.vue?vue&type=script&lang=js"
export * from "./Memorandums.vue?vue&type=script&lang=js"
import style0 from "./Memorandums.vue?vue&type=style&index=0&id=8e4f3906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4f3906",
  null
  
)

export default component.exports